var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1190_964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.75L12.5 12.5M7.1875 13.125C7.96722 13.125 8.73931 12.9714 9.45968 12.673C10.1801 12.3746 10.8346 11.9373 11.3859 11.3859C11.9373 10.8346 12.3746 10.1801 12.673 9.45968C12.9714 8.73931 13.125 7.96722 13.125 7.1875C13.125 6.40778 12.9714 5.63569 12.673 4.91532C12.3746 4.19495 11.9373 3.5404 11.3859 2.98905C10.8346 2.43771 10.1801 2.00035 9.45968 1.70197C8.73931 1.40358 7.96722 1.25 7.1875 1.25C5.61278 1.25 4.10255 1.87556 2.98905 2.98905C1.87556 4.10255 1.25 5.61278 1.25 7.1875C1.25 8.76222 1.87556 10.2724 2.98905 11.3859C4.10255 12.4994 5.61278 13.125 7.1875 13.125Z",
    stroke: "#221C35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1190_964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearchIcon);
export default __webpack_public_path__ + "static/media/header_search_icon.81168a813ac8748697e05a0a71f89405.svg";
export { ForwardRef as ReactComponent };